import { workflowApi } from './workflowApiBase';
import {
  Workflow,
  CreateWorkflowRequest,
  UpdateWorkflowRequest,
  WorkflowByIdRequest,
} from './types';

export const workflowMutationsApi = workflowApi.injectEndpoints({
  endpoints: (builder) => ({
    createWorkflow: builder.mutation<Workflow, CreateWorkflowRequest>({
      query: (request) => ({
        url: 'workflows',
        method: 'POST',
        body: request,
      }),
      invalidatesTags: ['WorkflowList'],
    }),

    updateWorkflow: builder.mutation<Workflow, UpdateWorkflowRequest>({
      query: (request) => ({
        url: 'workflows',
        method: 'PUT',
        body: request,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Workflow', id },
        'WorkflowList',
      ],
    }),

    activateWorkflow: builder.mutation<Workflow, WorkflowByIdRequest>({
      query: (request) => ({
        url: 'workflows/activate',
        method: 'POST',
        params: { id: request.id },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Workflow', id },
        'WorkflowList',
      ],
    }),

    deactivateWorkflow: builder.mutation<Workflow, WorkflowByIdRequest>({
      query: (request) => ({
        url: 'workflows/deactivate',
        method: 'POST',
        params: { id: request.id },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Workflow', id },
        'WorkflowList',
      ],
    }),

    deleteWorkflow: builder.mutation<boolean, WorkflowByIdRequest>({
      query: (request) => ({
        url: 'workflows/delete',
        method: 'DELETE',
        params: { id: request.id },
      }),
      invalidatesTags: ['WorkflowList'],
    }),
  }),
});

export const {
  useCreateWorkflowMutation,
  useUpdateWorkflowMutation,
  useActivateWorkflowMutation,
  useDeactivateWorkflowMutation,
  useDeleteWorkflowMutation,
} = workflowMutationsApi;
